import { ComponentInstall } from "../../utils";
import Tag from "./src";

export default ComponentInstall(Tag);
